export default function store() {
    const searchJson = window.sessionStorage.getItem("search");

    let searchInitialState;
    let initialState = {};

    try {
        searchInitialState = JSON.parse(searchJson);
    }
    catch (ex) {
        searchInitialState = null;
    }

    if (searchInitialState) {
        initialState = Object.assign({}, initialState, { search: searchInitialState });
    }

    return initialState;
}
